import { type SxProps } from '@mui/material'

export const cardStyles: SxProps = {
  borderRadius: '12px',
  width: '100%'
}

export const accordionSummaryStyles: SxProps = {
  display: 'flex',
  alignItems: 'center'
}

export const avatarContainerStyles: SxProps = {
  flex: '0 0 10%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}

export const avatarStyles: SxProps = {
  width: '100%',
  height: '100%'
}

export const detailsContainerStyles: SxProps = {
  flex: 1
}

export const avatarButtonContainerStyles: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '12px'
}

export const seeImageIconBoxStyles: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  height: '10vh',
  cursor: 'pointer'
}

export const seeImageIconStyles: SxProps = {
  height: '100%',
  width: '80%'
}

export const skeletonStyles: SxProps = {
  height: '4vh'
}
